import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHttpResult, interfaces } from '@leandredev/dcbm-common-lib';
import * as dcbm from '@leandredev/dcbm-ng-lib';
import { IHttpOption } from '@leandredev/dcbm-ng-lib';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SignInJwtService } from '../signIn-jwt/signIn-jwt.service';

@Injectable()
export class ClientService implements Partial<dcbm.service.UserClientAdmin> {
  private service: dcbm.service.UserClientAdmin;

  constructor(private http: HttpClient, private signInJwt: SignInJwtService) {
    this.service = new dcbm.service.UserClientAdmin(this.http, true);
    this.service.urlCollection = `${environment.data.api}userClientAdmin/`;
  }

  public deleteRgpdData(actId: string): Observable<IHttpResult<string>> {
    return this.service.deleteUserClientData({}, actId);
  }

  create<T extends interfaces.IUserClient, U extends interfaces.IUserClient>(body: U, query: any, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.create(body, query, options);
  }

  activateDevice<T extends interfaces.IUserDevices>(body: any, query: any, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.activateDevice(body, query, options);
  }

  resetAccount<T extends interfaces.IUserClient>(userId: string): Observable<IHttpResult<T>> {
    return this.service.resetAccount({}, userId);
  }

  public downloadUserData(actId: string): void {
    const url = `${environment.data.api}userClientAdmin/data/${encodeURIComponent(actId)}`;

    this.http.get(url, { observe: 'response', responseType: 'blob', headers: { JWT: this.signInJwt.token() } }).subscribe({
      next: (response) => {
        if (!response.body) return;

        const contentDisposition = response.headers.get('Content-Disposition');
        const filename = contentDisposition?.match(/filename="?([^";]+)"?/i)?.[1] ?? 'documents.zip';
        const objectUrl = window.URL.createObjectURL(response.body);
        const link = document.createElement('a');

        link.href = objectUrl;
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectUrl);
      },
      error: (error) => {
        console.error('Impossible de télécharger les données utilisateur.', error);
      }
    });
  }
}
